module.exports = __webpack_public_path__ + "img/arrow_grey.b97f681c.svg";